export const ROSTER_DAILY_CONFIG = {
  CONTENT_PANEL_WIDTH: 320,
  HOUR_BLOCK_HEIGHT: 34,
  HOUR_BLOCK_WIDTH: 240,
  CONTENT_GROUP_HEIGHT: 56,
  TIMELINE_ROW_HEIGHT: 90,
  TIMELINE_CARD_HEIGHT: 90 - 8,
  TIMELINE_CARD_PADDING: 4,
  FOOTER_BLOCK_HEIGHT: 18,
};
